import axios from "../../axios";
// Bare client for cross-origin third-party APIs — no Fantasy baseURL,
// interceptors, or credentials attached.
import externalAxios from "axios";
import { getURLString } from "../../index";
import { LEAGUE_BUSTER } from "../../../../Common/busters";
// import { DUMMY_DATA } from "../../../../ReusableComponents/Overlays/DriverConstructorInfo/driverConstructorDataConfig";
const URLString = (url) => getURLString(BASE_ROUTE, url);
const URLStringV2 = (url) => getURLString(BASE_ROUTE_V2, url);
const UserFeedsURLString = (url) => getURLString(USER_FEEDS_BASE_ROUTE, url);

const BASE_ROUTE = `feeds`;
const BASE_ROUTE_V2 = `feeds/v2`;
const USER_FEEDS_BASE_ROUTE = `userfeeds`;
const SERVICES_LEADERBOARD_BASE_ROUTE = `services/user/leaderboard`;
const ServicesLeaderboardURLString = (url) => getURLString(SERVICES_LEADERBOARD_BASE_ROUTE, url);
const RACE_DAY_SCHEDULE = (languageCode = "en") =>
  `schedule/raceday_${languageCode}.json`;
const DRIVERS_LIST = (gameDayId, languageCode = "en") =>
  `drivers/${gameDayId}_${languageCode}.json`;
const BOOSTERS_LIST = `booster/boosters.json`;
const CONSTRAINTS = `limits/constraints.json`;
const COUNTRIES = `countrylist/countries.json`;
const CIRCUIT_CONFIGURATION = (languageCode = "en") =>
  `circuit/configurations_${languageCode}.json`;
const LEAGUE_MARKETING = (leagueType, regionPath, leagueSlug) =>
  `leagues/${leagueType}/${regionPath}/${leagueSlug}.json`;

const SWAP_SUGGESTION_URL = (gamedayId) => `swapsuggestion/${gamedayId}.json`;

const GLOBAL_LEADER_BOARD = (optType, tourGameDayId, phaseId) =>
  `leaderboard/public/global/list_${optType}_${tourGameDayId}_${phaseId}.json`;

const UNJOINED_SPONSORED_PRIVATE_LEADER_BOARD = (
  optType,
  leagueId,
  tourGameDayId,
  phaseId
) =>
  `leaderboard/sponsorleague/list_${optType}_${leagueId}_${tourGameDayId}_${phaseId}.json`;

const COUNTRY_LEADER_BOARD = (optType, leagueId, tourGameDayId, phaseId) =>
  `leaderboard/public/country/list_${optType}_${leagueId}_${tourGameDayId}_${phaseId}.json`;

const DRIVER_LEADER_BOARD = (optType, leagueId, tourGameDayId, phaseId) =>
  `leaderboard/public/driver/list_${optType}_${leagueId}_${tourGameDayId}_${phaseId}.json`;

const TEAM_LEADER_BOARD = (optType, leagueId, tourGameDayId, phaseId) =>
  `leaderboard/public/team/list_${optType}_${leagueId}_${tourGameDayId}_${phaseId}.json`;

const USER_PUBLIC_LEADER_BOARD = (optType, leagueId, tourGameDayId, phaseId) =>
  `leaderboard/publicleague/list_${optType}_${leagueId}_${tourGameDayId}_${phaseId}.json`;

const MINI_LEAGUE_LEADER_BOARD = (optType, leagueId, tourGameDayId, phaseId) =>
  `leaderboard/minileague/list_${optType}_${leagueId}_${tourGameDayId}_${phaseId}.json`;

const PRIVATE_LEAGUE_LEADER_BOARD = (optType, leagueId, tourGameDayId, phaseId) =>
  `leaderboard/privateleague/list_${optType}_${leagueId}_${tourGameDayId}_${phaseId}.json`;

const MIX_API = `live/mixapi.json`;

const F1_MENU_ITEMS = `footer/f1_menu_items.json`;

const GET_TOP_PUBLIC_LEAGUES = "leagues/public/list.json";

const INFO_POPUP_CONFIG = "gamecontrol/infopopupconfig_1.json";

const ANNOUNCEMENT_POPUP_CONFIG = "gamecontrol/announcementconfig_1.json";

const RATING_STATS = `leagues/filter/rating_stats_2.json`;

const SORTING_STATS = `leagues/filter/sorting_stats_2.json`;

const CLOUDINARY_CONFIG_URL = `cloudinary/config.json`;

export function getRatingStatistics() {
  return axios.get(URLString(RATING_STATS), {
    feedBuster: true,
  });
}

export function getSortingStatistics() {
  return axios.get(URLString(SORTING_STATS), {
    feedBuster: true,
  });
}

export function getRaceDaySchedule(params) {
  const { languageCode } = params;
  return axios.get(URLString(RACE_DAY_SCHEDULE(languageCode)), {
    feedBuster: true,
  });
}

export function getDriversList(params) {
  const { gameDayId, languageCode, livePointsBuster = false } = params;
  return axios.get(URLString(DRIVERS_LIST(gameDayId, languageCode)), {
    feedBuster: true,
    livePointsBuster,
  });
}

export function getBoostersList() {
  return axios.get(URLString(BOOSTERS_LIST), {
    feedBuster: true,
  });
}

export function getConstraints() {
  return axios.get(URLString(CONSTRAINTS), {
    feedBuster: true,
  });
}

export function getCountries() {
  return axios.get(URLString(COUNTRIES), {
    feedBuster: true,
  });
}

export function getCircuitConfiguration(params) {
  const { languageCode } = params;
  return axios.get(URLString(CIRCUIT_CONFIGURATION(languageCode)), {
    feedBuster: true,
  });
}

export function getGlobalLeaderBoard(params) {
  const { optType, tourGameDayId, phaseId } = params;
  return axios.get(
    URLString(GLOBAL_LEADER_BOARD(optType, tourGameDayId, phaseId)),
    {
      feedBuster: true,
    }
  );
}

export function getUnjoinedSponsoredPrivateLeaderBoard(params) {
  const { optType, tourGameDayId, phaseId, leagueId } = params;
  return axios.get(
    URLString(
      UNJOINED_SPONSORED_PRIVATE_LEADER_BOARD(
        optType,
        leagueId,
        tourGameDayId,
        phaseId
      )
    ),
    {
      feedBuster: true,
    }
  );
}

export function getCountryLeaderBoard(params) {
  const { optType, tourGameDayId = 0, phaseId, leagueId } = params;
  return axios.get(
    URLString(COUNTRY_LEADER_BOARD(optType, leagueId, tourGameDayId, phaseId)),
    {
      feedBuster: true,
    }
  );
}

export function getDriverLeaderBoard(params) {
  const { optType, tourGameDayId = 0, phaseId, leagueId } = params;
  return axios.get(
    URLString(DRIVER_LEADER_BOARD(optType, leagueId, tourGameDayId, phaseId)),
    {
      feedBuster: true,
    }
  );
}

export function getFavoriteTeamLeaderBoard(params) {
  const { optType, tourGameDayId = 0, phaseId, leagueId } = params;
  return axios.get(
    URLString(TEAM_LEADER_BOARD(optType, leagueId, tourGameDayId, phaseId)),
    {
      feedBuster: true,
    }
  );
}

export function getPublicLeaderBoard(params) {
  const { optType, leagueId, tourGameDayId, phaseId } = params;
  return axios.get(
    URLString(
      USER_PUBLIC_LEADER_BOARD(optType, leagueId, tourGameDayId, phaseId)
    ),
    {
      feedBuster: true,
    }
  );
}

export function getMiniLeagueLeaderBoard(params) {
  const { optType, leagueId, tourGameDayId, phaseId } = params;
  return axios.get(
    URLString(
      MINI_LEAGUE_LEADER_BOARD(optType, leagueId, tourGameDayId, phaseId)
    ),
    {
      feedBuster: true,
    }
  );
}

export function getPrivateLeagueLeaderBoard(params) {
  const { optType, leagueId, tourGameDayId, phaseId } = params;
  const url = PRIVATE_LEAGUE_LEADER_BOARD(optType, leagueId, tourGameDayId, phaseId);
  return axios.get(URLString(url), {
    feedBuster: true,
  });
}

export function getPlayerStatistics(playerId, livePointsBuster) {
  return axios.get(URLString(`popup/playerstats_${playerId}.json`), {
    feedBuster: true,
    livePointsBuster,
  });
}

export function getMixAPI() {
  return axios.get(URLString(MIX_API), {
    params: {
      buster: Date.now(),
    },
  });
}

export function getFooterPartners() {
  return axios.get(URLString("footer/partners.json"), {
    feedBuster: true,
  });
}

export function getAgeGateConfig() {
  return axios.get(URLString("lists/age-gate-config.json"), {
    feedBuster: true,
  });
}

export function getGeolocationV2(url) {
  // Digitas-hosted whereami v2 lives on a different domain than the Fantasy
  // backend. The shared axios instance must not be used here: it would attach
  // the Fantasy baseURL, unwrap Meta/Data response envelopes, and re-login +
  // retry on 401 — none of which apply to this unauthenticated cross-origin
  // request (and the retry would hammer the Fantasy session API on a Digitas
  // outage). The full URL comes from web config (see useWhereAmIV2).
  return externalAxios.get(url);
}

export function getF1MenuItems() {
  return axios.get(URLString(F1_MENU_ITEMS), {
    feedBuster: true,
  });
}

export function getTopPublicLeagues() {
  return axios.get(URLString(GET_TOP_PUBLIC_LEAGUES), {
    feedBuster: true,
  });
}

export const getMiniLeaguesPrizes = () => {
  return axios.get(URLString("lists/mini-leagues.json"), {
    feedBuster: true,
  });
};

export function getDriverStatistics(params) {
  const { url = "", tourId } = params;
  const urlPath = url?.replace("{tourId}", tourId);
  return axios.get(URLString(urlPath), {
    feedBuster: true,
  });
}

export function getConstructorStatistics(params) {
  const { url = "", tourId } = params;
  const urlPath = url?.replace("{tourId}", tourId);
  return axios.get(URLString(urlPath), {
    feedBuster: true,
  });
}

export function getFeedbackQuestions(params) {
  const { url = "marketingoptin/question_en" } = params;
  return axios.get(URLString(url), { feedBuster: true });
}

export function getUserEOSStats(path, socialID) {
  const url = path?.replace("{socialId}", socialID);
  return axios.get(url, {
    feedBuster: true,
  });
}

export function getOverallEOSStats(params) {
  const { url, tourId } = params;
  const urlPath = url?.replace("{tourId}", tourId);
  return axios.get(URLString(urlPath), {
    feedBuster: true,
  });
}

export function getEOSConfig() {
  return axios.get(URLString(`eos/config.json`), {
    feedBuster: true,
  });
}

export function getWEBConfig() {
  return axios.get(URLString(`apps/web_config.json`), {
    feedBuster: true,
  });
}

export function getHomepageStats(params) {
  const { url, tourId } = params;
  const urlPath = url?.replace("{tourId}", tourId);
  return axios.get(URLString(urlPath), {
    // feedBuster: true,
    feedGenericCardBuster: true,
  });
}

export function getSeasonPerformance(params) {
  const { url, yearId } = params;
  const urlPath = url?.replace("{year}", yearId);
  return axios.get(UserFeedsURLString(urlPath), {
    feedBuster: true,
  });
}

export function getLeaguesFilterAndSort(params) {
  const { url, tourId } = params;
  const urlPath = url?.replace("{tourId}", tourId);

  return axios.get(URLString(urlPath), {
    feedBuster: true,
  });
}

export function getCloudinaryConfig() {
  return axios.get(URLString(CLOUDINARY_CONFIG_URL), {
    feedBuster: true,
  });
}

export function getSwapSuggestions({ gamedayId }) {
  return axios.get(URLString(SWAP_SUGGESTION_URL(gamedayId)), {
    feedBuster: true,
  });
}

export function getCommonConfigV2() {
  return axios.get(URLStringV2(`apps/web_config.json`), {
    feedConfigBuster: true,
  });
}

export function getCommonStatisticsV2(params) {
  const { url, tourId } = params;
  const urlPath = url?.replace("{tourId}", tourId);
  return axios.get(URLStringV2(urlPath), {
    feedStatisticsBuster: true,
  });
}

export function getFixtureCircuitConfigV2(params) {
  const { languageCode } = params;
  return axios.get(URLStringV2(RACE_DAY_SCHEDULE(languageCode)), {
    feedFixturesBuster: true,
  });
}

export function getMasterConfig(params) {
  const { countryCode, language, alcoholGate, bettingGate, regionSuffix } =
    params || {};
  const path = regionSuffix
    ? `regional/${countryCode.toLowerCase()}/config_master_${language}_${alcoholGate}_${bettingGate}_${regionSuffix.toLowerCase()}.json`
    : `regional/${countryCode.toLowerCase()}/config_master_${language}_${alcoholGate}_${bettingGate}.json`;
  return axios.get(URLString(path), { feedFixturesBuster: true });
}

export function getMasterManifest() {
  return axios.get(URLString("regional/master_manifest.json"), {
    feedConfigBuster: true,
  });
}

export function getSponsorsConfig() {
  return axios.get(URLString("static-assets/sponsors.json"), {
    feedConfigBuster: true,
  });
}

export function getLeagueMarketing(params) {
  const { leagueType, leagueSlug, regionPath = "default" } = params;
  return axios.get(
    URLString(LEAGUE_MARKETING(leagueType, regionPath, leagueSlug)),
    {
      feedBuster: true,
    }
  );
}

// Self-rank API for all league types
// Endpoint: /services/user/leaderboard/{guid}/userrankgetv1/{tourGamedayId}/{leaderboardType}/{leagueType}/{leagueId}
export function getLeaderboardSelfRank(params) {
  const { guid, tourGamedayId, leaderboardType, leagueType, leagueId } = params;
  const url = `${guid}/userrankgetv1/${tourGamedayId}/${leaderboardType}/${leagueType}/${leagueId}`;
  return axios.get(ServicesLeaderboardURLString(url), {
    addBusterIfAvailable: true,
    busterCookieName: LEAGUE_BUSTER,
  });
}
